// extracted by mini-css-extract-plugin
export default {"root":"LogoContainer_root__X1zLu","logoUsc":"LogoContainer_logoUsc__xwtde","logoRrc":"LogoContainer_logoRrc__6RVyy"};